// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-user-img {
  width: 46px;
  height: 46px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E7ECF0;
}

.status-true {
  color: #FF3C3C;
}

.status-false {
  color: #10B981;
}

.clearBtn {
  background: none;
  border: none;
  padding-right: 10px;
  cursor: pointer;
}

.MRN-id {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5019607843);
}

.m-l-5 {
  margin-left: 5px;
}

.gc-agency-handle {
  width: 160px;
}

.m-l-24 {
  margin-left: 24px;
}

.p-button.button-sm {
  height: 32px;
  line-height: 15px;
  font-size: 14px;
  font-weight: 300;
  margin-right: 10px;
}

.gap-1 {
  gap: 1rem;
}

.w-165 {
  width: 165px !important;
}

.responsive-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.col-doc {
  min-width: 140px !important;
  max-width: 220px !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.col-recipient {
  min-width: 140px !important;
  max-width: 220px !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
}

.col-date {
  min-width: 130px !important;
  white-space: nowrap !important;
}

.col-status {
  min-width: 90px !important;
  text-align: center !important;
}

.col-action {
  min-width: 80px !important;
  text-align: center !important;
}

.col-resends {
  min-width: 80px !important;
  text-align: center !important;
}

/* PDF.js Annotation Layer styles moved to global styles.scss to avoid Angular ViewEncapsulation */
/* Premium PDF Loading Overlay */
.pdf-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.45); /* Elegant dark glass tint */
  backdrop-filter: blur(8px); /* Soft modern blur */
  -webkit-backdrop-filter: blur(8px);
  z-index: 11000; /* Keep it above PrimeNG sidebar and dialogs */
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.25s ease-out;
}

.pdf-loading-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  width: 90%;
  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleUp {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
::ng-deep .p-accordion .p-accordion-tab {
  margin-bottom: 12px;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
  padding: 1.25rem 1.5rem !important;
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  text-decoration: none !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05) !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon {
  color: #64748b !important;
  font-size: 1.1rem !important;
  margin-right: 1rem !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-header.p-accordion-header-active .p-accordion-header-link {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  box-shadow: none !important;
}
::ng-deep .p-accordion .p-accordion-tab .p-accordion-content {
  border: 1px solid #e2e8f0 !important;
  border-top: none !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  padding: 1.5rem !important;
  background: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

/* Dropdown Clear Icon styling to prevent overlapping text */
::ng-deep .p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 3.5rem !important;
}
::ng-deep .p-dropdown.p-dropdown-clearable .p-dropdown-clear-icon {
  background: #ffffff !important;
  padding: 3px !important;
  border-radius: 50% !important;
  right: 2.2rem !important;
  color: #ef4444 !important; /* soft red cross */
  font-weight: bold !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 16px !important;
  height: 16px !important;
  font-size: 10px !important;
}

/* Visual PDF Form Mapping Overlays and Selector Menu */
::ng-deep .assigned-sig-field, ::ng-deep .assigned-date-field, ::ng-deep .unassigned-sig-field {
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
::ng-deep .assigned-sig-field:hover, ::ng-deep .assigned-date-field:hover, ::ng-deep .unassigned-sig-field:hover {
  filter: brightness(0.95);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
::ng-deep .field-assignment-badge {
  font-family: "Montserrat", sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  line-height: 1.2 !important;
}

.signer-select-popup {
  font-family: "Montserrat", sans-serif;
  animation: fadeInFast 0.15s ease-out;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

@keyframes fadeInFast {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
::ng-deep .pdf-form-fill-dialog {
  /* Top-align the dialog (position="top" on the p-dialog) instead of vertical-centering,
     so the large empty margin above the modal is removed; a small top margin keeps it from
     being glued to the browser chrome. The leftover vertical slack now sits below the modal. */
}
::ng-deep .pdf-form-fill-dialog .p-dialog {
  margin-top: 1rem !important;
}
::ng-deep .pdf-form-fill-dialog .p-dialog-content {
  overflow: visible !important;
  /* Trim the default content top padding so the form/document sits right under the
     header instead of floating with a large empty gap above it. */
  padding-top: 0.5rem !important;
}

::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 16px !important;
  padding: 20px 24px !important;
  background: #fff !important;
  border-top: 1px solid #e5e7eb !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .p-button {
  width: auto !important;
  min-width: 140px !important;
  height: 48px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
  letter-spacing: -0.25px !important;
  box-shadow: none !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn {
  background-color: #fff !important;
  border: 1px solid #2d388b !important;
  color: #2d388b !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn:enabled:hover, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn:enabled:hover {
  background-color: #f3f4f6 !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.close-btn:disabled, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-cancel.save-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send {
  /* IOHB-1632: the pale custom green never read as "ready". Match the app's
     standard green button (.esign-green-btn / \$Green) so it's consistent with
     the other enabled green buttons. */
  background-color: #6ACE6A !important;
  color: #ffffff !important;
  border: 1px solid #6ACE6A !important;
  /* IOHB-1632 follow-up: a disabled button must not stay vibrant green —
     users read it as clickable and get no feedback. Mute it like the other
     disabled buttons in this footer. */
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:hover {
  background-color: #7AEC7A !important;
  border-color: #7AEC7A !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:focus, ::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:enabled:active {
  background-color: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .eSockUpdate-confirmation-dialog .p-sidebar-footer.button-container .btn-save-send:disabled {
  opacity: 0.5 !important;
  background-color: #9ca3af !important;
  border-color: #9ca3af !important;
  color: #f3f4f6 !important;
  cursor: not-allowed !important;
}

::ng-deep .pdf-zoom-controls {
  position: absolute;
  right: 28px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}
::ng-deep .pdf-zoom-controls button {
  width: 38px !important;
  height: 38px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #2D388B !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  padding: 0 !important;
  transition: transform 0.1s ease, background-color 0.2s;
}
::ng-deep .pdf-zoom-controls button:hover:not(:disabled) {
  background-color: #f9fafb !important;
  transform: scale(1.05);
}
::ng-deep .pdf-zoom-controls button:active:not(:disabled) {
  transform: scale(0.95);
}
::ng-deep .pdf-zoom-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
::ng-deep .pdf-zoom-controls button i {
  font-size: 14px !important;
  font-weight: 700 !important;
}
::ng-deep .pdf-zoom-controls .zoom-percent {
  width: 38px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #2D388B;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 4px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

@media (max-width: 991px), (pointer: coarse) {
  ::ng-deep .pdf-zoom-controls {
    top: 12px !important;
    right: 12px !important;
    bottom: auto !important;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
